(() => {
  const page = document.querySelector('[data-pesukarhu-order]');
  if (!page) return;

  const labels = page.dataset;
  if (!/^\d+$/.test(labels.formId || '')) return;
  const hostSelector = `[data-forms-id="forms-root-${labels.formId}"] shopify-forms-embed`;
  const vendors = [labels.productVendor, labels.productVendorAlias].filter(Boolean).map(value => value.trim().toLowerCase());
  const fieldIds = {
    first_name: 'first', last_name: 'last', email: 'email', phone_number: 'phone',
    'custom#company_or_organisation': 'company', 'custom#estimated_quantity': 'quantity',
    'custom#dimensions_or_specifications': 'dimensions', 'custom#delivery_country': 'delivery',
    'custom#project_file-field': 'file',
  };
  const optionalFields = ['dimensions', 'date', 'branding'];
  const fieldLayout = {
    type: ['1 / -1', '1', '2'], brief: ['1 / 3', '4 / 8', '8'],
    quantity: ['1', '9', '10'], delivery: ['2', '9', '10'],
    dimensions: ['1 / 3', '13', '14'], date: ['1 / 3', '15', '16'],
    branding: ['1 / 3', '17', '18'], file: ['1 / 3', '19', '20'],
    first: ['4', '4', '5'], last: ['5', '4', '5'],
    email: ['4 / 6', '6', '7'], phone: ['4 / 6', '9', '10'], company: ['4 / 6', '11', '12'],
  };
  let contextPrefix = '';
  let root;
  let observer;

  const makeHeading = (key, text) => {
    const heading = document.createElement('h2');
    heading.dataset.quoteHeading = key;
    const number = document.createElement('span');
    number.dataset.quoteStep = '';
    number.setAttribute('aria-hidden', 'true');
    number.textContent = key === 'project' ? '01' : '02';
    heading.append(number, document.createTextNode(text));
    return heading;
  };

  const prefill = form => {
    const brief = form.querySelector('[name="custom#project_details"]');
    if (!brief || !contextPrefix || brief.dataset.quotePrefilled || brief.value.trim()) return;
    // Use the native setter so Shopify's controlled field receives the context too.
    Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, 'value').set.call(brief, contextPrefix);
    brief.dispatchEvent(new Event('input', { bubbles: true }));
    brief.dataset.quotePrefilled = 'true';
  };

  const syncFields = form => {
    const fields = {};
    // Position Shopify-owned fields and errors without reparenting React's DOM.
    for (const child of form.children) {
      let key = child.matches('fieldset[name="custom#request_type"]') ? 'type' : null;
      if (child.querySelector('[name="custom#project_details"]')) key = 'brief';
      if (child.querySelector('[name="custom#branding_notes"]')) key = 'branding';
      if (child.matches('[data-testid="date-birthday"]')) key = 'date';
      for (const input of child.querySelectorAll('input')) key = fieldIds[input.id] || key;
      if (!key) continue;
      child.dataset.quoteField = key;
      child.style.setProperty('--quote-column', fieldLayout[key][0]);
      child.style.setProperty('--quote-row', fieldLayout[key][1]);
      fields[key] = child;
      if (optionalFields.includes(key)) child.dataset.quoteOptional = '';
      for (const textarea of child.querySelectorAll('textarea')) {
        textarea.id ||= textarea.name;
        textarea.setAttribute('aria-labelledby', `label-${textarea.name}`);
      }
    }
    for (const error of form.querySelectorAll(':scope > [role="alert"]')) {
      let previous = error.previousElementSibling;
      while (previous?.matches('[data-quote-heading], [data-quote-optional-toggle]')) previous = previous.previousElementSibling;
      const key = previous?.dataset.quoteField;
      if (!fieldLayout[key]) continue;
      error.dataset.quoteError = key;
      error.style.setProperty('--quote-column', fieldLayout[key][0]);
      error.style.setProperty('--quote-row', fieldLayout[key][2]);
    }
    for (const input of fields.type?.querySelectorAll('input[type="radio"]') || []) {
      const label = input.closest('label');
      if (!label || label.querySelector('[data-quote-choice-icon]')) continue;
      const template = page.querySelector(`template[data-quote-choice="${CSS.escape(input.value)}"]`) || page.querySelector('template[data-quote-choice="other"]');
      const icon = template?.content.firstElementChild?.cloneNode(true);
      if (icon) {
        icon.dataset.quoteChoiceIcon = '';
        label.prepend(icon);
      }
    }
    return fields;
  };

  const enhance = () => {
    const form = root?.querySelector('form[data-testid="form"]');
    if (!form) return;
    const fields = syncFields(form);
    if (form.dataset.quoteReady) {
      const optional = [...form.querySelectorAll('[data-quote-optional]')];
      const hiddenError = optional.some(field => field.hidden && (
        field.querySelector('[aria-invalid="true"], [role="alert"]') || field.nextElementSibling?.matches('[role="alert"]')
      ));
      if (hiddenError) {
        optional.forEach(field => { field.hidden = false; });
        form.querySelector('[data-quote-optional-toggle]')?.setAttribute('aria-expanded', 'true');
      }
      prefill(form);
      return;
    }
    if (!fields.type || !fields.brief || !fields.first) return;
    form.dataset.quoteReady = 'true';
    form.addEventListener('submit', enhance, { capture: true });
    const header = form.previousElementSibling;
    if (header) header.dataset.quoteNativeHeader = '';

    form.insertBefore(makeHeading('project', labels.projectLabel), fields.brief);
    form.insertBefore(makeHeading('contact', labels.contactLabel), fields.first);

    if (fields.dimensions) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.dataset.quoteOptionalToggle = '';
      toggle.textContent = labels.optionalLabel;
      toggle.setAttribute('aria-expanded', 'false');
      const controlled = optionalFields.filter(key => fields[key]).map(key => {
        fields[key].id = `quote-optional-${key}`;
        fields[key].hidden = true;
        return fields[key].id;
      });
      toggle.setAttribute('aria-controls', controlled.join(' '));
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        optionalFields.forEach(key => { if (fields[key]) fields[key].hidden = !expanded; });
      });
      form.insertBefore(toggle, fields.dimensions);
    }

    if (fields.file) {
      const hint = document.createElement('p');
      hint.className = 'quote-file-hint';
      hint.id = 'quote-file-hint';
      hint.textContent = labels.attachmentHint;
      fields.file.append(hint);
      fields.file.querySelector('input').setAttribute('aria-describedby', hint.id);
    }
    const note = document.createElement('p');
    note.className = 'quote-note';
    note.textContent = labels.formNote;
    form.append(note);

    for (const [id, value] of Object.entries({first_name: 'given-name', last_name: 'family-name', email: 'email', phone_number: 'tel', 'custom#company_or_organisation': 'organization', 'custom#delivery_country': 'country-name'})) {
      const input = root.getElementById(id);
      if (input) input.autocomplete = value;
    }
    prefill(form);
  };

  const loadProduct = async () => {
    const params = new URLSearchParams(location.search);
    const handle = params.get('product');
    if (!handle || !/^[a-z0-9][a-z0-9-]{0,200}$/.test(handle)) return;
    const base = labels.rootUrl.replace(/\/$/, '');
    try {
      const response = await fetch(`${base}/products/${encodeURIComponent(handle)}.js`);
      if (!response.ok) return;
      const product = await response.json();
      if (!vendors.includes(product.vendor?.trim().toLowerCase())) return;
      const variant = product.variants.find(item => String(item.id) === params.get('variant'));
      const url = new URL(`${base}/products/${encodeURIComponent(handle)}`, location.origin);
      if (variant) url.searchParams.set('variant', variant.id);
      const variantTitle = variant?.title !== 'Default Title' ? variant?.title : '';
      contextPrefix = `${labels.productLabel}: ${product.title}\n${variantTitle ? `${labels.variantLabel}: ${variantTitle}\n` : ''}${url.href}\n\n`;
      const link = page.querySelector('[data-quote-product]');
      link.textContent = product.title;
      link.href = url.href;
      page.querySelector('[data-quote-variant]').textContent = variantTitle || '';
      const image = page.querySelector('[data-quote-image]');
      const source = variant?.featured_image?.src || product.featured_image;
      if (source) {
        const imageUrl = new URL(source, location.origin);
        if (imageUrl.protocol === 'https:') {
          imageUrl.searchParams.set('width', '112');
          image.src = imageUrl.href;
          image.hidden = false;
        }
      }
      page.querySelector('[data-quote-context]').hidden = false;
      enhance();
    } catch { /* An unavailable product must not prevent a general enquiry. */ }
  };

  const connect = () => {
    root = document.querySelector(hostSelector)?.shadowRoot;
    if (!root) return false;
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = labels.formStyle;
    root.append(style);
    observer = new MutationObserver(enhance);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-invalid'] });
    enhance();
    return true;
  };
  let attempts = 0;
  const initialise = () => {
    if (connect() || ++attempts > 300) return;
    window.setTimeout(initialise, 100);
  };
  initialise();
  loadProduct();
  window.addEventListener('pagehide', () => observer?.disconnect(), { once: true });
})();
